import { Type } from 'class-transformer';
import { Model } from './model';
import { Call } from './call';
import { Email } from './email';
import { EmailThread } from './email_thread';
import { Task } from './task';

export class Conversation extends Model {
  type: string;

  @Type(() => Object, {
    discriminator: {
      property: 'object',
      subTypes: [
        { value: Call, name: 'call' },
        { value: Email, name: 'email' },
        { value: EmailThread, name: 'email_thread' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  data: Email | EmailThread | Call;

  get id(): string {
    return this.data.id;
  }

  get isCall() {
    return this.type === 'call';
  }

  get isEmail() {
    return this.type === 'email';
  }

  get isEmailThread() {
    return this.type === 'email_thread';
  }
}
